import React from 'react';

import {
  CloudSunRainSolidIcon,
  FlagCheckeredSolidIcon,
  MountainsSolidIcon,
  RoadSolidIcon,
  SnowflakeSolidIcon,
  SunSolidIcon,
  ThreePeakMountainLightIcon,
  TirePressureWarningSolidIcon
} from '../../../../shared/icons/icons';
import FuelEfficiencyImage from '../fuel-efficiency-image/fuel-efficiency-image';

import { TIRE_ATTRIBUTES } from '../../../../shared/constants/products';

import './tire-attribute-icon.scss';

interface TireAttributeIconProps {
  className?: string;
  name: string;
}

const TIRE_ATTRIBUTE_ICON_MAP = {
  [TIRE_ATTRIBUTES.ALL_SEASON]: {
    icon: CloudSunRainSolidIcon
  },
  [TIRE_ATTRIBUTES.ALL_TERRAIN]: {
    icon: MountainsSolidIcon
  },
  [TIRE_ATTRIBUTES.COMPETION]: {
    icon: FlagCheckeredSolidIcon
  },
  [TIRE_ATTRIBUTES.PERFORMANCE]: {
    icon: FlagCheckeredSolidIcon
  },
  [TIRE_ATTRIBUTES.RUN_FLAT]: {
    icon: TirePressureWarningSolidIcon
  },
  [TIRE_ATTRIBUTES.SUMMER]: {
    icon: SunSolidIcon
  },
  [TIRE_ATTRIBUTES.TOURING]: {
    icon: RoadSolidIcon
  },
  [TIRE_ATTRIBUTES.TREADWELL_FUEL_EFFICIENT]: {
    icon: FuelEfficiencyImage
  },
  [TIRE_ATTRIBUTES.WINTER]: {
    icon: SnowflakeSolidIcon
  },
  [TIRE_ATTRIBUTES.THREE_PEAK_MOUNTAIN]: {
    icon: ThreePeakMountainLightIcon
  }
};

function TireAttributeIcon(props: TireAttributeIconProps) {
  const { className, name } = props;

  const Icon = TIRE_ATTRIBUTE_ICON_MAP[name]?.icon;

  return <Icon className={className} styleName="icon" />;
}

export default TireAttributeIcon;
